import React, { useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { GET_INVITE_CODE_AGENT_TAB, GET_INVITE_CODE_AGENTS, GET_SERVICES_FROM_INVITE_CODE } from './queries';
import PLFilters from '../../../../../../components/PL/PLFilters';
import { SERVICES_TABLE_TYPE } from '../../../../../../components/PL/PLTable/config';
import PLTable from '../../../../../../components/PL/PLTable/PLTable';
import { useHistory, useLocation } from 'react-router-dom';
import { getPaginatedTableVariablesByTypeAndSearchTypeScript } from '../../../../../../components/PL/PLTable/TypeScriptHelpers';
import { useSelector } from 'react-redux';
import { getFiltersProp } from '../../../../../../redux/selectors/CurrentUserSelectors';
import * as strings from './strings';
import { PLFILTER_TYPE_SERVICE } from '../../../../../../components/PL/PLFilters/config';

export default function InviteCodeServicesTab({ inviteId }: InviteCodeServicesTabProps) {
	const history = useHistory();
	const filters = useSelector(getFiltersProp);
	const location = useLocation();
	let props = {
		filters,
		location
	};

	const [photoshoots, setPhotoshoots] = useState<ServiceType[]>();
	const [getServices, { data: serviceData }] = useLazyQuery(GET_SERVICES_FROM_INVITE_CODE);
	const [getAgent, { data: agentData }] = useLazyQuery(GET_INVITE_CODE_AGENTS);

	const [getInviteCode, { data: inviteCodeData }] = useLazyQuery(GET_INVITE_CODE_AGENT_TAB, {
		variables: { q: { id: { op_eq: inviteId } } }
	});

	useEffect(() => {
		(async () => {
			await getInviteCode();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (inviteCodeData) {
				getAgent({
					variables: { q: { inviteCode: { op_eq: inviteCodeData.forms[0].inviteCode } } }
				});
			}
		})();
	}, [inviteCodeData]);

	useEffect(() => {
		(async () => {
			if (agentData) {
				let baseVariables = { q: { agentId: { op_in: agentData.users.map((agent) => agent.id) } } };
				let variables = getPaginatedTableVariablesByTypeAndSearchTypeScript(50, SERVICES_TABLE_TYPE, props, baseVariables);
				getServices({ variables });
			}
		})();
	}, [agentData]);

	useEffect(() => {
		(async () => {
			if (serviceData) {
				setPhotoshoots(serviceData.services);
			}
		})();
	}, [serviceData]);

	if (!inviteCodeData || !photoshoots) return null;

	return (
		<div className='servicesUsed'>
			<div className='servicesUsed__filter'>
				<PLFilters type={PLFILTER_TYPE_SERVICE} updateTable={() => getInviteCode()} />
			</div>
			<p className='servicesUsed__title'>{strings.servicesTitle}</p>
			<PLTable
				type={SERVICES_TABLE_TYPE}
				data={photoshoots}
				onSelect={(service) => history.push('/service/' + service.id)}
				limit={1000}
				updateTable={getInviteCode}
			/>
		</div>
	);
}
